<template>
    <section>
        <!-- START NAV -->
        <nav class="navbar is-white">
            <div class="container">
                <div class="navbar-brand">
                    <router-link tag="a" :to="{name: 'dashboard'}">
                        <img :src="require('../../assets/images/logo_cts.jpg')" alt="logo" class="logo">
                    </router-link>

                    <div class="navbar-burger burger is-hidden-tablet" data-target="navMenu" @click.prevent="showBurgerMenu" >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div id="navMenu" class="is-hidden-desktop" :class="{'is-hidden': hideBurgerMenu }" >
                    <div class="navbar-start">
                        <router-link tag="a" :to="{name: 'dashboard'}" class="navbar-item" v-on:click.native="showBurgerMenu">Inicio</router-link>
                        <router-link tag="a" :to="{name: 'account.status'}" class="navbar-item">Estado de cuenta</router-link>
                        <router-link tag="a" :to="{name: 'documents'}" class="navbar-item">Certificados</router-link>
                        <router-link tag="a" :to="{name: 'profile'}" class="navbar-item">Perfil</router-link>
                        <a href="#" @click.prevent="signOut" class="navbar-item">Cerrar Sesión</a>
                    </div>
                </div>
            </div>
        </nav>
        <!-- END NAV -->
        <transition name="slide-down" mode="out-in">
            <error></error>
        </transition>
        <transition name="slide-down" mode="out-in">
            <primary></primary>
        </transition>

        <div class="container">
            <div class="columns">

                <!-- SIDEBAR -->
                <div class="column is-3 ">
                    <aside class="menu is-hidden-mobile">
                        <p class="menu-label">
                            <!-- General -->
                        </p>
                        <ul class="menu-list">
                            <li>
                                <router-link tag="a" :to="{name: 'dashboard'}">Inicio</router-link>
                            </li>
                            <li>
                                <a href="http://tssantafesur.org.ar/">Web del Colegio</a>
                            </li>
                        </ul>
                        <p class="menu-label">
                            Documentación
                        </p>
                        <ul class="menu-list">
                            <li>
                                <router-link tag="a" :to="{name: 'account.status'}">Estado de cuenta</router-link>
                            </li>
                            <li>
                                <router-link tag="a" :to="{name: 'documents'}">Certificados</router-link>
                            </li>
                        </ul>

                        <span v-if="user.level>0">
                            <p class="menu-label">
                                Administración
                            </p>
                            <ul class="menu-list">
                                <li>
                                    <router-link tag="a" :to="{name: 'users'}">Usuarios</router-link>
                                </li>
                            </ul>
                        </span>

                        <p class="menu-label">
                            Configuración
                        </p>
                        <ul class="menu-list">
                            <li>
                                <router-link tag="a" :to="{name: 'profile'}">Perfil</router-link>
                            </li>
                            <li>
                                <a href="#" @click.prevent="signOut">Cerrar Sesión</a>
                            </li>
                        </ul>
                    </aside>
                </div>
                <!-- END SIDEBAR -->

                <!-- MAIN -->
                <transition name="fade" mode="out-in">
                    <router-view/>
                </transition>
                <!-- END MAIN -->
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import error from '../components/notificacion/error'
import primary from '../components/notificacion/primary'

export default {
    name: 'home',
    data() {
        return {
            hideBurgerMenu: true,
        }
    },
    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            errors: 'auth/errors'
        }),
    },
    components: {
        error, primary
    },
    watch: {
        '$route' () {
            this.hideBurgerMenu = true
        }
    },
    methods: {
        ...mapActions({
            signOutAction: 'auth/signOut',
        }),
        showBurgerMenu() {
            this.hideBurgerMenu = !this.hideBurgerMenu
        },
        signOut() {
            this.signOutAction().then(() => {
                this.$router.replace({
                    name: 'auth.login'
                })
            })
        },
    }
}
</script>

<style>
    html, body {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
        font-size: 16px;
        line-height: 1.5;
        height: 100%;
        background: #ECF0F3;
    }
    nav.navbar {
        border-top: 4px solid #276cda;
        margin-bottom: 1rem;
    }
    .navbar-item.brand-text {

    }
    .navbar-item, .navbar-link {
        font-size: 14px;
        font-weight: 700;
    }
    .columns {
        width: 100%;
        height: 100%;
        margin-left: 0;
    }
    .menu-label {
        color: #8F99A3;
        letter-spacing: 1.3;
        font-weight: 700;
    }
    .menu-list a {
        color: #0F1D38;
        font-size: 14px;
        font-weight: 700;
    }
    .menu-list a:hover {
        background-color: transparent;
        color: #276cda;
    }
    .menu-list a.is-active {
        background-color: transparent;
        color: #276cda;
        font-weight: 700;
    }
    .card {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
        margin-bottom: 2rem;
    }
    .card-header-title {
        color: #8F99A3;
        font-weight: 400;
    }
    .info-tiles {
        margin: 1rem 0;
    }
    .info-tiles .subtitle {
        font-weight: 300;
        color: #8F99A3;
    }
    .hero.welcome.is-info {
        background: #36D1DC;
        background: -webkit-linear-gradient(to right, #5B86E5, #36D1DC);
        background: linear-gradient(to right, #5B86E5, #36D1DC);
    }
    .hero.welcome .title, .hero.welcome .subtitle {
        color: hsl(192, 17%, 99%);
    }
    .card .content {
        font-size: 14px;
    }
    .card-footer-item {
        font-size: 14px;
        font-weight: 700;
        color: #8F99A3;
    }
    .card-footer-item:hover {
    }
    .card-table .table {
        margin-bottom: 0;
    }
    .events-card .card-table {
        max-height: 250px;
        overflow-y: scroll;
    }

    a .logo{ height: 50px; }

    .is-clickable {
        cursor: pointer;
        transition:box-shadow 2s, transform 500ms, filter 500ms ease-in-out;
    }
    .is-clickable:hover{
        transform: scale(1.05);
    }

    @media (max-width: 1023px) {
        section div .register {
            margin-top: 0;
        }

        .columns .column.left{
            border-right: none;
        }

        .columns .column.left,
        .columns .column.right{
            padding: 1.5rem 3.5rem;
        }
    }
</style>